import {Dispatch, useCallback} from 'react';
import {ActionTypes, AutomationAction} from '../reducer/actions';
import {AutomationContextType, AutomationFilter} from '../reducer/model';
import {RuleType} from '../enums';
import {AlertListItem} from '../reducer/types';
import {priority} from '@priority-software/priority-proto-api/lib';

export const useAutomationCommonHandlers = (dispatch: Dispatch<AutomationAction>) => {
    /* COMMON API */
    const setFilter = useCallback((data: AutomationFilter) => {
        dispatch({type: ActionTypes.SET_APPLIED_FILTERS, payload: {filter: data}});
    }, []);

    const removeFilter = useCallback((filterName: string, value: string | number) => {
        dispatch({type: ActionTypes.REMOVE_APPLIED_FILTERS, payload: {filterName, value}});
    }, []);

    const handleFilters = useCallback(() => {
        dispatch({type: ActionTypes.HANDLE_RULE_FILTERS});
    }, []);

    const handleAutomationOpen = useCallback(
        () => dispatch({type: ActionTypes.OPEN_AUTOMATION}),
        []
    );

    const handleDialogType = useCallback(
        (type: RuleType) =>
            dispatch({
                type: ActionTypes.SET_AUTOMATION_TYPE,
                payload: {type}
            }),
        []
    );

    const openRuleDialog = useCallback(async () => {
        dispatch({type: ActionTypes.OPEN_SINGLE_RULE, payload: {}});
    }, []);

    const closeSingleRuleDialog = useCallback(
        () => dispatch({type: ActionTypes.CLOSE_SINGLE_RULE}),
        []
    );

    const handleSearch = useCallback((searchValue: string = '') => {
        dispatch({type: ActionTypes.HANDLE_SEARCH, payload: {searchValue}});
        dispatch({type: ActionTypes.HANDLE_RULE_FILTERS});
    }, []);

    const setRules = useCallback((rules: Array<AlertListItem>) => {
        dispatch({type: ActionTypes.SET_AUTOMATION_RULES, payload: {rules}});
        dispatch({type: ActionTypes.HANDLE_RULE_FILTERS});
    }, []);

    const setSelectedRuleIndex = useCallback((index: number) => {
        dispatch({type: ActionTypes.SET_SELECTED_RULE_INDEX, payload: {index}});
    }, []);

    const updateOpenRule = useCallback(async (data: Partial<priority.netitems.form.IAlert>) => {
        dispatch({type: ActionTypes.UPDATE_OPEN_RULE, payload: {data}});
    }, []);

    const dispatchState = useCallback(async (data: Partial<AutomationContextType>) => {
        dispatch({type: ActionTypes.DISPATCH_STATE, payload: data});
    }, []);

    const handleAIRuleSuggestions = useCallback(async data => {
        dispatch({type: ActionTypes.SET_AI_RULE_SUGGESTION, payload: data});
    }, []);

    return {
        setFilter,
        removeFilter,
        handleFilters,
        handleAutomationOpen,
        handleDialogType,
        openRuleDialog,
        closeSingleRuleDialog,
        handleSearch,
        setRules,
        setSelectedRuleIndex,
        updateOpenRule,
        handleAIRuleSuggestions,
        dispatchState
    };
};
